<h3 class="super-compos-titre-h3 mt-3">Membres</h3>
<div [formGroup]="membersForm" class="form mb-2">
  <div class="row">
    <div class="col-11">
      <!-- ! vérifier si le p-autocomplete fonctionne => component non utilisé au 08/09/25 => suite au passage en 17, l'autocomplete n'a pas été revu. -->
      <p-autoComplete
        [unique]="true"
        formControlName="members"
        [suggestions]="filteredContacts | sort: 'nom' : 'ASC'"
        styleClass="w-75"
        (completeMethod)="search($event, 'contact')"
        field="name"
        dataKey="id"
        placeholder="Recherchez et ajoutez un membre par son nom ou prénom"
        [multiple]="true"
        (onSelect)="onSelectMember($event)"
        [forceSelection]="true"
        autocomplete="new-password"
        name="members">
      </p-autoComplete>
    </div>
    <div class="col-1 d-flex justify-content-end">
      <i-button
        icon="bi bi-person-add"
        text="Ajouter"
        (click)="addContact()"
        styleClass="green w-100"
        tooltip="Ajouter un contact non présent dans la liste"></i-button>
    </div>
  </div>
</div>

<p-table
  #dt
  [value]="linksMembers"
  [columns]="columns"
  dataKey="linkId"
  [responsive]="true"
  class="super-table"
  tableStyleClass="super-table"
  editMode="row"
  [paginator]="true"
  [rows]="5"
  [totalRecords]="linksMembers.length">
  <ng-template pTemplate="header" let-columns>
    <tr>
      @for (col of columns; track col; let i = $index) {
        <th [id]="col.field" [pSortableColumn]="col.field">
          {{ col.header }}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-ri="rowIndex" let-editing="editing">
    <tr [pEditableRow]="rowData">
      <td>
        <div class="tdApList">{{ rowData.nameContact1 }}</div>
      </td>

      <td>
        <p-cellEditor>
          <ng-template pTemplate="input">
            <p-dropdown
              [disabled]="!editing"
              [options]="typesRelations"
              [showClear]="true"
              appendTo="body"
              [(ngModel)]="rowData.contactsLiensMembresRelations"
              placeholder="Relation"
              styleClass="w-100 customDrop">
              <ng-template let-item pTemplate="selectedItem"> {{ item?.label }} </ng-template>
              <ng-template let-lien pTemplate="item"> {{ lien?.label }} </ng-template>
            </p-dropdown>
          </ng-template>
          <ng-template pTemplate="output"> {{ rowData?.contactsLiensMembresRelations?.label }} </ng-template>
        </p-cellEditor>
      </td>
      <td>
        <div class="tdApList">{{ rowData.nameContact2 }}</div>
      </td>

      <td>
        <p-cellEditor>
          <ng-template pTemplate="input">
            <p-dropdown
              [disabled]="!editing"
              [options]="contactFctList"
              appendTo="body"
              [(ngModel)]="rowData.fonction"
              placeholder="Fonction"
              styleClass="w-100 customDrop">
              <ng-template let-item pTemplate="selectedItem"> {{ item?.label }} </ng-template>
              <ng-template let-fonction pTemplate="item"> {{ fonction?.label }} </ng-template>
            </p-dropdown>
          </ng-template>

          <ng-template pTemplate="output">
            {{ rowData?.fonction?.label }}
            @if (!rowData?.fonction?.label) {
              <span class="input-error">La fonction est requise</span>
            }
          </ng-template>
        </p-cellEditor>
      </td>

      <td>
        <div class="d-flex justify-content-center align-items-center">
          @if (!editing) {
            <button
              pButton
              pRipple
              type="button"
              pInitEditableRow
              icon="pi pi-pencil"
              (click)="onRowEditInit(rowData)"
              class="p-button-rounded p-button-text me-3"></button>
          }
          @if (!editing) {
            <span (click)="remove(rowData)">
              <i class="bi bi-x-circle redIcon iconSmall"></i>
            </span>
          }

          @if (editing) {
            <button
              [disabled]="emailInvalid || !rowData?.fonction"
              pButton
              pRipple
              type="button"
              pSaveEditableRow
              icon="pi pi-check"
              (click)="onRowEditSave(rowData)"
              class="p-button-rounded p-button-text p-button-success"></button>
          }
          @if (editing) {
            <button
              pButton
              pRipple
              type="button"
              pCancelEditableRow
              icon="pi pi-times"
              (click)="onRowEditCancel(ri)"
              class="p-button-rounded p-button-text p-button-danger customBtnColorRed"></button>
          }
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
